/**
 * Soft Motion — Product USP + Colour Switch
 * Custom "SWITCH COLOURS" cursor; click cycles colour panels.
 */
(function () {
  var ATTR = 'data-ls-product-usp-colour-switch';
  var sectionCleanups = new WeakMap();

  function prefersFinePointer() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function isDesktopViewport() {
    return window.matchMedia('(min-width: 1024px)').matches;
  }

  function canUseCustomCursor() {
    return isDesktopViewport() && prefersFinePointer();
  }

  function initSection(root) {
    if (!root || root.getAttribute('data-ls-usp-ready') === 'true') return;

    var panels = root.querySelectorAll('[data-ls-usp-panel]');
    if (!panels.length) return;

    root.setAttribute('data-ls-usp-ready', 'true');

    var switchEl = root.querySelector('[data-ls-usp-switch]');
    var switchButton = root.querySelector('[data-ls-usp-cycle]');
    var thumbImg = root.querySelector('[data-ls-usp-switch-thumb]');
    var swatchEl = root.querySelector('[data-ls-usp-switch-swatch]');
    var colourCount = panels.length;
    var activeIndex = 0;

    for (var i = 0; i < panels.length; i++) {
      if (panels[i].classList.contains('is-active')) {
        activeIndex = i;
        break;
      }
    }

    function nextIndex(from) {
      return (from + 1) % colourCount;
    }

    function updateSwitchPreview(forIndex) {
      if (!switchEl || colourCount < 2) return;

      var previewIndex = nextIndex(forIndex);
      var panel = panels[previewIndex];
      var previewSrc = panel.getAttribute('data-preview-src') || '';
      var previewHex = panel.getAttribute('data-swatch-hex') || '';

      if (thumbImg) {
        if (previewSrc) {
          thumbImg.src = previewSrc;
          thumbImg.hidden = false;
        } else {
          thumbImg.removeAttribute('src');
          thumbImg.hidden = true;
        }
      }

      if (swatchEl) {
        if (previewHex) {
          swatchEl.style.backgroundColor = previewHex;
          swatchEl.hidden = false;
        } else {
          swatchEl.style.backgroundColor = '';
          swatchEl.hidden = true;
        }
      }
    }

    function setActive(index) {
      if (index < 0 || index >= colourCount) return;
      activeIndex = index;

      for (var p = 0; p < panels.length; p++) {
        var isActive = p === activeIndex;
        panels[p].classList.toggle('is-active', isActive);
        if (isActive) {
          panels[p].removeAttribute('hidden');
        } else {
          panels[p].setAttribute('hidden', '');
        }
      }

      root.setAttribute('data-active-colour', panels[activeIndex].getAttribute('data-colour-key') || '');
      updateSwitchPreview(activeIndex);
    }

    function cycleColour(event) {
      if (colourCount < 2) return;
      if (event) {
        var target = event.target;
        if (target && target.closest && target.closest('a, button')) {
          return;
        }
      }
      setActive(nextIndex(activeIndex));
    }

    function onSwitchButtonClick() {
      cycleColour();
    }

    updateSwitchPreview(activeIndex);

    /* Warm all colour images so first switch isn't a grey flash (hidden panels defer load) */
    function preloadColourImages() {
      Array.prototype.forEach.call(root.querySelectorAll('img.ls-product-usp-colour-switch__media-image, img.ls-product-usp-colour-switch__card-image'), function (img) {
        if (!img || img.complete) return;
        var warm = new Image();
        if (img.sizes) warm.sizes = img.sizes;
        if (img.srcset) warm.srcset = img.srcset;
        if (img.currentSrc) {
          warm.src = img.currentSrc;
        } else if (img.src) {
          warm.src = img.src;
        }
      });
    }
    preloadColourImages();

    if (colourCount > 1) {
      root.classList.add('ls-product-usp-colour-switch--interactive');
      root.addEventListener('click', cycleColour);
      if (switchButton) {
        switchButton.addEventListener('click', onSwitchButtonClick);
      }
    } else {
      root.classList.add('ls-product-usp-colour-switch--single');
    }

    /* Custom cursor (desktop / fine pointer only) */
    var cursorEnabled = false;
    var rafId = 0;
    var pendingX = 0;
    var pendingY = 0;
    var scrollSyncBound = false;

    function moveSwitch() {
      rafId = 0;
      if (!switchEl || !cursorEnabled) return;
      switchEl.style.left = pendingX + 'px';
      switchEl.style.top = pendingY + 'px';
    }

    function hideCursor() {
      cursorEnabled = false;
      root.classList.remove('is-cursor-visible');
      if (rafId) {
        window.cancelAnimationFrame(rafId);
        rafId = 0;
      }
      if (switchEl) {
        switchEl.style.left = '';
        switchEl.style.top = '';
      }
    }

    function pointInRoot(x, y) {
      var rect = root.getBoundingClientRect();
      return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
    }

    /* pointerleave often misses on fast scroll — section moves, pointer does not */
    function syncCursorAgainstPointer() {
      if (!cursorEnabled) return;
      if (!canUseCustomCursor() || !pointInRoot(pendingX, pendingY)) {
        hideCursor();
      }
    }

    function onPointerMove(event) {
      if (!cursorEnabled || !switchEl) return;
      pendingX = event.clientX;
      pendingY = event.clientY;
      if (!canUseCustomCursor() || !pointInRoot(pendingX, pendingY)) {
        hideCursor();
        return;
      }
      if (!rafId) {
        rafId = window.requestAnimationFrame(moveSwitch);
      }
    }

    function onPointerEnter(event) {
      if (!canUseCustomCursor() || colourCount < 2) return;
      pendingX = event.clientX;
      pendingY = event.clientY;
      cursorEnabled = true;
      root.classList.add('is-cursor-visible');
      if (!rafId) {
        rafId = window.requestAnimationFrame(moveSwitch);
      }
    }

    function onPointerLeave() {
      hideCursor();
    }

    function bindScrollSync() {
      if (scrollSyncBound) return;
      scrollSyncBound = true;
      window.addEventListener('scroll', syncCursorAgainstPointer, true);
      window.addEventListener('resize', syncCursorAgainstPointer);
      document.addEventListener('visibilitychange', onVisibilityChange);
    }

    function unbindScrollSync() {
      if (!scrollSyncBound) return;
      scrollSyncBound = false;
      window.removeEventListener('scroll', syncCursorAgainstPointer, true);
      window.removeEventListener('resize', syncCursorAgainstPointer);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    }

    function onVisibilityChange() {
      if (document.hidden) hideCursor();
    }

    function syncPointerMode() {
      if (canUseCustomCursor() && colourCount > 1) {
        root.addEventListener('pointermove', onPointerMove);
        root.addEventListener('pointerenter', onPointerEnter);
        root.addEventListener('pointerleave', onPointerLeave);
        bindScrollSync();
      } else {
        root.removeEventListener('pointermove', onPointerMove);
        root.removeEventListener('pointerenter', onPointerEnter);
        root.removeEventListener('pointerleave', onPointerLeave);
        unbindScrollSync();
        hideCursor();
      }
    }

    syncPointerMode();

    var mqPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    var mqDesktop = window.matchMedia('(min-width: 1024px)');
    function bindMq(mq) {
      if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', syncPointerMode);
      } else if (typeof mq.addListener === 'function') {
        mq.addListener(syncPointerMode);
      }
    }

    function unbindMq(mq) {
      if (typeof mq.removeEventListener === 'function') {
        mq.removeEventListener('change', syncPointerMode);
      } else if (typeof mq.removeListener === 'function') {
        mq.removeListener(syncPointerMode);
      }
    }

    bindMq(mqPointer);
    bindMq(mqDesktop);

    sectionCleanups.set(root, function () {
      root.removeEventListener('click', cycleColour);
      if (switchButton) {
        switchButton.removeEventListener('click', onSwitchButtonClick);
      }
      root.removeEventListener('pointermove', onPointerMove);
      root.removeEventListener('pointerenter', onPointerEnter);
      root.removeEventListener('pointerleave', onPointerLeave);
      unbindScrollSync();
      unbindMq(mqPointer);
      unbindMq(mqDesktop);
      hideCursor();
      root.removeAttribute('data-ls-usp-ready');
      sectionCleanups.delete(root);
    });
  }

  function cleanupSection(root) {
    var cleanup = sectionCleanups.get(root);
    if (cleanup) cleanup();
  }

  function initAll(scope) {
    if (!scope) return;
    if (scope.nodeType === 1 && scope.matches && scope.matches('[' + ATTR + ']')) {
      initSection(scope);
    }
    if (typeof scope.querySelectorAll === 'function') {
      Array.prototype.forEach.call(scope.querySelectorAll('[' + ATTR + ']'), initSection);
    }
  }

  function cleanupAll(scope) {
    if (!scope) return;
    if (scope.nodeType === 1 && scope.matches && scope.matches('[' + ATTR + ']')) {
      cleanupSection(scope);
    }
    if (typeof scope.querySelectorAll === 'function') {
      Array.prototype.forEach.call(scope.querySelectorAll('[' + ATTR + ']'), cleanupSection);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    cleanupAll(event.target);
  });
})();
